import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag-list-atom',
  templateUrl: './tag-list-atom.component.html',
})
export class TagListAtomComponent {
  @Input() tags!: any[];
}
